import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">

      {/* Main footer content */}
      <div className="footer-main">
        <div className="footer-content">
          {/* Left side - Company Info */}
          <div className="footer-company">
            <h2>Inifiy</h2>
            <p>
              Your trusted marketplace for quality products from verified vendors. 
              We connect customers with reliable sellers, offering a seamless shopping 
              experience with secure payments, fast shipping, and excellent customer 
              support. Discover amazing products at competitive prices.
            </p>
          </div>

          {/* Right side - Quick Links */}
          <div className="footer-quick-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/vendor/login">Seller Login</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="footer-bottom">
        <div className="footer-copyright">
          <p>&copy; 1996-2024, Inifiy.com, Inc. or its affiliates</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 